import InfoIcon from "@mui/icons-material/Info";
import { SvgIconProps } from "@mui/material";

export const Info = (props: SvgIconProps) => {
  return <InfoIcon data-testcomp="Icon_Info" {...props} />;
};
